import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceInfo from '@/views/资讯管理/service/DZServiceInfo';
import UIEditor from "@/components/ui-editor/UIEditor.vue"
import ny_config from "@/api/nyConfig";
import api from "@/api/nyApiJson";
import dzMsgBox from "@/utils/DZMessageBox";

@Component({
    components: {UIEditor}
})
export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    s_info = new DZServiceInfo();

    bindImage(id) {
        if (!id) {
            return "";
        }
        let apiName = "显示图片";
        let apiJson: ny_config = api[apiName];
        let url = apiJson.baseUrl + apiJson.url + "?image=" + id
        return url;
    }

    bindReadNum(num){
        if(!num){
            return 0;
        }else{
            return num;
        }
    }

    created() {
        this.action_list_data()
        this.s_info.net_all_type()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    /**
     * 查
     */
    action_list_data(){
        this.s_info.net_page_list_info(this.s_info.m_search);
    }
    action_page_change(cur_page){
        this.s_info.m_search.pageNum = cur_page;
        this.action_list_data();
    }

    /**
     * 增
     */
    action_add_info(){
        this.$router.push({ path: '/information/info'})
    }

    /**
     * 改
     * @param id
     */
    action_handle_edit(id){
        this.$router.push({ path: '/information/info', query: { id:id } })
    }

    /**
     * 删
     */
    action_del_info(id){
        dzMsgBox.del("是否删除该信息？", () => {
            this.s_info.net_del_info(id,() => {
                this.action_list_data()
            });
        })
    }

    handleDbClick(row){
        if(row.id){
            this.action_handle_edit(row.id)
        }
    }

    handleSizeChange(val){
        this.s_info.m_search.pageSize = val
        this.action_list_data()
    }
}
